<div
  class="relative"
  matTooltipPosition="above"
  [matTooltip]="'shared.platformFeatures.' + typeFormatted() | translate"
  [matTooltipDisabled]="!showTooltip()"
>
  @if (isLive()) {
    <div
      class="absolute top-[-2px] right-[-4px] w-3 h-3 bg-shikenso-success-base rounded-full border-2 border-white z-10"
    ></div>
  }

  <app-icon-badge
    borderColor="var(--shikenso-base-white)"
    [content]="currentConfig()?.icon ?? platformConfig['noPlatform'].icon"
    [backgroundColor]="computedBackgroundColor()"
    [borderWidth]="borderWidth()"
    [borderRadius]="borderRadius()"
    [size]="size()"
    [noMaskSize]="!!currentConfig()?.noMaskSize"
    [color]="computedColor()"
    [iconSize]="iconSize()"
    [isSocialBadge]="true"
    [showAuthenticationIcon]="showAuthenticationIcon()"
  />
</div>
